import Api from './api';

const slug = 'v1/notifications';
export default {
  getNotifications() {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  clearNotifications() {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}`)
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkNotifications() {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/check`)
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  pushNotification(payload) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}`, payload)
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
